import Alert, { AlertType, AlertStatus } from '@alltrails/shared/types/alert';

const isClosureOrDangerAlertActive = (alert: Alert) => {
  return (alert.alertType === AlertType.CLOSURE || alert.alertType === AlertType.DANGER) && alert.status === AlertStatus.ACTIVE;
};

export default isClosureOrDangerAlertActive;
